/**
 * 订单/流水 pay_type 展示与筛选项（含斗拱 dougong / dougong_fq_*）
 */

export const PAY_TYPE_LABEL_MAP = {
  adapay: '微信支付',
  dougong: '微信支付(斗拱)',
  adapay_fq_hua_bei: '花呗支付',
  dougong_fq_hua_bei: '花呗支付(斗拱)',
  adapay_fq_credit_card: '支付宝信用卡分期',
  dougong_fq_credit_card: '支付宝信用卡分期(斗拱)',
  adapay_fq_other: '支付宝其他',
  adapay_fq_jd: '京东白条',
  tradein: '以旧换新支付',
  china_ums: '云闪付支付',
  wxpay: '微信支付',
  wxpayapp: '微信APP支付',
  wxpayh5: '微信H5支付',
  wxpaypc: '微信PC支付',
  wxpaypos: '微信POS支付',
  wxpayjs: '微信JS支付',
  alipay: '支付宝支付',
  alipayapp: '支付宝APP支付',
  alipayh5: '支付宝H5支付',
  alipaypos: '支付宝POS支付',
  deposit: '余额支付',
  ebuy: 'EBUY支付',
  point: '积分支付',
  pos: 'POS银行卡支付',
  appointment: '预约支付'
}

/** 订单列表「支付方式」筛选项 */
export const ORDER_PAY_METHOD_OPTIONS = [
  { label: '微信支付', value: 'adapay' },
  { label: '微信支付(斗拱)', value: 'dougong' },
  { label: '花呗支付', value: 'adapay_fq_hua_bei' },
  { label: '花呗支付(斗拱)', value: 'dougong_fq_hua_bei' },
  { label: '支付宝信用卡分期', value: 'adapay_fq_credit_card' },
  { label: '支付宝信用卡分期(斗拱)', value: 'dougong_fq_credit_card' }
]

/** 订单列表「实际支付类型 / fund_channel」筛选项 */
export const ORDER_FUND_TYPE_OPTIONS = [
  { label: '微信线上支付', value: 'adapay_online' },
  { label: '微信线下支付', value: 'adapay' },
  { label: '微信线上支付(斗拱)', value: 'dougong_online' },
  { label: '微信线下支付(斗拱)', value: 'dougong' },
  { label: '花呗支付', value: 'adapay_fq_hua_bei' },
  { label: '花呗支付(斗拱)', value: 'dougong_fq_hua_bei' },
  { label: '支付宝信用卡分期', value: 'adapay_fq_credit_card' },
  { label: '支付宝信用卡分期(斗拱)', value: 'dougong_fq_credit_card' },
  { label: '支付宝其他', value: 'adapay_fq_other' }
]

/** 资金流水筛选项 - pay_type */
export const CAPITAL_PAY_TYPE_OPTIONS = [
  { name: '全部', value: '' },
  { name: '旧机回收', value: 'tradein' },
  { name: '微信支付', value: 'adapay' },
  { name: '微信支付(斗拱)', value: 'dougong' },
  { name: '花呗支付', value: 'adapay_fq_hua_bei' },
  { name: '花呗支付(斗拱)', value: 'dougong_fq_hua_bei' },
  { name: '支付宝信用卡分期', value: 'adapay_fq_credit_card' },
  { name: '支付宝信用卡分期(斗拱)', value: 'dougong_fq_credit_card' }
]

/** 资金流水筛选项 - fund_channel */
export const CAPITAL_FUND_TYPE_OPTIONS = [
  { name: '选择实际支付类型', value: '' },
  { name: '旧机回收', value: 'tradein' },
  { name: '微信线下支付', value: 'adapay' },
  { name: '微信线上支付', value: 'adapay_online' },
  { name: '微信线上支付(斗拱)', value: 'dougong_online' },
  { name: '微信线下支付(斗拱)', value: 'dougong' },
  { name: '花呗支付', value: 'adapay_fq_hua_bei' },
  { name: '花呗支付(斗拱)', value: 'dougong_fq_hua_bei' },
  { name: '支付宝信用卡分期', value: 'adapay_fq_credit_card' },
  { name: '支付宝信用卡分期(斗拱)', value: 'dougong_fq_credit_card' },
  { name: '支付宝其他', value: 'adapay_fq_other' }
]

export const FUND_FQ_NUM_OPTIONS = [
  { label: '3期', value: '3' },
  { label: '6期', value: '6' },
  { label: '12期', value: '12' },
  { label: '24期', value: '24' },
]

export function isFqPayType(payType) {
  return /^(adapay|dougong)_fq_/.test(String(payType || ''))
}

/**
 * @param {string} payType
 * @param {{ pay_source?: string }} [row]
 */
export function getPayTypeLabel(payType, row) {
  const code = String(payType || '')
  if (!code) {
    return '-'
  }
  if (code === 'adapay' && row && row.pay_source) {
    return row.pay_source === 'online' ? '微信线上支付' : '微信线下支付'
  }
  if (code === 'dougong' && row && row.pay_source) {
    return row.pay_source === 'online' ? '微信线上支付(斗拱)' : '微信线下支付(斗拱)'
  }
  return PAY_TYPE_LABEL_MAP[code] || code
}

export function getPayMethodOptionLabel(value, options = ORDER_PAY_METHOD_OPTIONS) {
  const hit = options.find((item) => item.value === value)
  if (hit) {
    return hit.label || hit.name
  }
  return getPayTypeLabel(value)
}
